import * as channelSagas from './channels';
import * as channelsRoutines from '../channelRoutines';
import * as messageSagas from './messages';
import * as paths from '../../../Providers/paths';
import * as rootSelectors from '../../../selectors/root';
import { all, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { rsf } from '../../../globals/firebase';
import { sendFile } from '../../../sagas/routines/fileRoutines';
import { sendStringSaga } from '../../../sagas/filesSaga';

const messagesTransformer = ({ value }) => {
    let res = {};

    for (let channel in value) {
        res[channel] = [];
        Object.keys(value[channel]).map(msg => {
            res[channel].push({ ...value[channel][msg], id: msg });
            return msg;
        });
    }
    return res;
};

function* syncChannelsSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleConfig(activeEvent, 'inbox', 'chat'), {
        successActionCreator: channelsRoutines.syncChannels.success,
        failureActionCreator: channelsRoutines.syncChannels.failure,
    });
}
export function* resetChannelSync() {
    yield put(channelsRoutines.stopSyncingChannels.trigger());
    yield put(channelsRoutines.syncChannels());
}

export function* rootChannelsWatcher() {
    yield all([
        takeEvery(sendFile.TRIGGER, sendStringSaga),
        takeEvery(channelsRoutines.updateChannel.TRIGGER, channelSagas.updateChannel),
        takeEvery(channelsRoutines.createChannel.TRIGGER, channelSagas.createNewChannel),
        takeEvery(channelsRoutines.removeChannel.TRIGGER, channelSagas.removeChannel),
        takeEvery(channelsRoutines.reorderChannels.TRIGGER, channelSagas.updateChannelOrder),
    ]);

    while (yield take(channelsRoutines.syncChannels.TRIGGER)) {
        const bgChannelsSync = yield fork(syncChannelsSaga);
        yield take(channelsRoutines.stopSyncingChannels.TRIGGER);
        yield cancel(bgChannelsSync);
    }
}

export function* syncChannelMessagesSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);

    yield fork(rsf.database.sync, paths.moduleData(activeEvent, 'chat', 'messages'), {
        successActionCreator: channelsRoutines.syncChannelMessages.success,
        failureActionCreator: channelsRoutines.syncChannelMessages.failure,
        transform: messagesTransformer,
    });
}

export function* resetMessageSync() {
    yield put(channelsRoutines.stopSyncingChannelMessages.trigger());
    yield put(channelsRoutines.syncChannelMessages());
}

export function* rootMessagesWatcher() {
    yield takeEvery(channelsRoutines.sendMessageAsAlertUser.TRIGGER, messageSagas.sendMessageSaga);
    yield takeEvery(channelsRoutines.toggleBlockChannelMessage.TRIGGER, messageSagas.blockMessage);

    while (yield take(channelsRoutines.syncChannelMessages.TRIGGER)) {
        const bgChannelMessagesSync = yield fork(syncChannelMessagesSaga);
        yield take(channelsRoutines.stopSyncingChannelMessages.TRIGGER);
        yield cancel(bgChannelMessagesSync);
    }
}
